import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { info } from 'octicons';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-c',
  templateUrl: './app-form-c.component.html',
  providers: [ObjetsService]
})
export class AppFormCComponent implements OnInit {
  public formName = 'rubrique_C_designation_bien';
  public formTooltip: any = [];
  public hiddenItems: any = [];
  public showItems: any = [];
  public country: any = [];
  public formIsValid = true;
  public metaData: any = [];
  public infoIcon: SafeHtml;

  /**
   * Liste des natures de locaux. Alimentée par loadListeRefnasodaf.
   * Le setter re-synchronise les selects nature après que les options sont rendues.
   */
  private _datas: any = [];
  get datas() { return this._datas; }
  set datas(value: any) {
    this._datas = value;
    if (value && value.length > 0) {
      // Après que Angular a rendu les options, forcer la re-synchronisation
      // des selects nature dont la valeur a été patchée avant l'arrivée des données
      setTimeout(() => this.resyncLotSelects());
    }
  }

  public static readonly MAX_LOTS = 7;
  public lotLimitReached = false;
  public validLots: Array<boolean> = [];

  private lineIndex = 0;
  private alive = true;
  private mutating = false;

  form1: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  formCopro: FormGroup;
  itemsF1: FormArray;
  itemsF2: FormArray;
  itemsF3: FormArray;

  constructor(
    private _objetsService: ObjetsService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private localStorageService: LocalStorageService
  ) {}

  get form1Data() { return <FormArray>this.form1.get('itemsF1'); }
  get form2Data() { return <FormArray>this.form2.get('itemsF2'); }
  get form3Data() { return <FormArray>this.form3.get('itemsF3'); }

  ngOnInit (): void {
    this.country = Object.keys(this._objetsService.getCountry()).map(key => ({type: key, value: this._objetsService.getCountry()[key]}));

    this.infoIcon = this.sanitizer.bypassSecurityTrustHtml(info.toSVG());

    this.loadListeRefnasodaf();

    this.form1 = new FormGroup({
      c_immeuble: new FormControl('', Validators.required),
      c_pleine_propriete: new FormControl(),
      c_nue_propriete: new FormControl(),
      c_usufruit: new FormControl(),
      c_type_vente_bat: new FormControl('', Validators.required),
      c_p__nom: new FormControl('', Validators.required),
      c_p__prenom: new FormControl('', Validators.required),
      c_adresse__country: new FormControl('', Validators.required),
      c_adresse__state: new FormControl(),
      c_adresse__nom: new FormControl(),
      c_adresse__numero: new FormControl(),
      c_adresse__type_voie: new FormControl(),
      c_adresse__extension: new FormControl(),
      c_adresse__lieu_dit_bp: new FormControl(),
      c_adresse__cp: new FormControl('', [Validators.required, Validators.pattern(/^\d{5}$/)]),
      c_adresse__localite: new FormControl('', Validators.required),
      c_ocp_sol_superficie__terres: new FormControl(),
      c_ocp_sol_superficie__pres: new FormControl(),
      c_ocp_sol_superficie__vergers: new FormControl(),
      c_ocp_sol_superficie__vignes: new FormControl(),
      c_ocp_sol_superficie__bois: new FormControl(),
      c_ocp_sol_superficie__landes: new FormControl(),
      c_ocp_sol_superficie__carrieres: new FormControl(),
      c_ocp_sol_superficie__eaux_cadastrees: new FormControl(),
      c_ocp_sol_superficie__jardins: new FormControl(),
      c_ocp_sol_superficie__terrain_batir: new FormControl(),
      c_ocp_sol_superficie__terrains_agrement: new FormControl(),
      c_ocp_sol_superficie__sol: new FormControl(),
      c_surf_const_sol: new FormControl(),
      c_surf_util: new FormControl(),
      c_immeuble_niveaux: new FormControl(),
      c_immeuble_appartements: new FormControl(),
      c_immeuble_autres_locaux: new FormControl(),
      c_vente_lot_col: new FormControl(),
      c_vente_lot_col__text: new FormControl(),
      c_lotissement: new FormControl(),
    }, {});

    this.form2 = new FormGroup({
      c_loc_bat_copro__numero: new FormControl(),
      c_loc_bat_copro__batiment: new FormControl(),
      c_loc_bat_copro__etage: new FormControl(),
      c_loc_bat_copro__quote_part: new FormControl('', [Validators.min(0), Validators.max(99)]),
      c_loc_bat_copro__nature: new FormControl(),
      c_loc_bat_copro__nature_preciser: new FormControl(),
      c_loc_bat_copro__surface: new FormControl(),
      c_loc_bat_copro__bat_acv: new FormControl(),
      c_loc_bat_copro__reg_cop: new FormControl(),
      c_loc_bat_copro__num_inscription_copropriete: new FormControl(),
      c_loc_bat_copro__indivision: new FormControl(),
    });

    this.form3 = new FormGroup({
      c_droit_sociaux__designation_societe: new FormControl(),
      c_droit_sociaux__designation_droit: new FormControl(),
      c_droit_sociaux__nature: new FormControl(),
      c_droit_sociaux__nombre_parts_cedees: new FormControl(),
      c_droit_sociaux__nombre_total_parts: new FormControl(),
      c_droit_sociaux__numero_parts: new FormControl(),
      c_droit_sociaux__majorite_parts: new FormControl(),
    });

    this.form1 = this.formBuilder.group({
      itemsF1: this.formBuilder.array([ this.createItem('form_part1') ])
    });

    this.form2 = this.formBuilder.group({
      itemsF2: this.formBuilder.array([ this.createItem('form_part2') ])
    });

    this.form3 = this.formBuilder.group({
      itemsF3: this.formBuilder.array([ this.createItem('form_part3') ])
    });

    this.formCopro = this.formBuilder.group({
      c_loc_bat_copro__bat_acv: '',
      c_loc_bat_copro__reg_cop: '',
      c_loc_bat_copro__num_inscription_copropriete: ''
    });

    // Propager les valeurs partagées vers tous les lots existants
    this.formCopro.valueChanges.subscribe(values => {
      this.propagateSharedFieldsToLots(values);
    });

    this.showItems[0] = true;

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form1.valueChanges.subscribe(() => this.saveToStorage());
    this.form2.valueChanges.subscribe(() => {
      if (!this.mutating) { this.saveToStorage(); }
    });
    this.form3.valueChanges.subscribe(() => this.saveToStorage());
    this.formCopro.valueChanges.subscribe(() => {
      // La propagation vers les lots est déjà gérée par l'abonnement dédié
    });

    this.getTooltip();
  }

  /**
   * Retourne le nombre de lots enregistrés (hors formulaire d'ajout vide).
   */
  get savedLotsCount(): number {
    return this.form2Data ? this.form2Data.length - 1 : 0;
  }

  /**
   * Ajoute un lot pour une location
   *
   * @param i
   */
  addItem(i): void {
    // Vérifier la limite de lots
    if (this.savedLotsCount >= AppFormCComponent.MAX_LOTS) {
      this.lotLimitReached = true;
      this.saveToStorage();
      return;
    }

    // Vérifier les champs requis
    const lot = this.form2Data.at(i);
    const numero = lot.get('c_loc_bat_copro__numero').value;
    const nature = lot.get('c_loc_bat_copro__nature').value;
    const surface = lot.get('c_loc_bat_copro__surface').value;
    const valid = (numero !== null && numero > 0)
      && (nature !== null && nature !== '')
      && (surface !== null && surface > 0);
    this.validLots[i] = valid;
    if (!valid) { return; }

    this.mutating = true;
    this.lineIndex = this.lineIndex + 1;
    this.showItems[this.lineIndex] = true;

    this.itemsF2 = this.form2.get('itemsF2') as FormArray;
    this.itemsF2.push(this.createItem('form_part2'));

    // Copier les valeurs partagées dans le lot qui vient d'être enregistré
    this.propagateSharedFieldsToLot(i);

    this.hiddenItems[i] = true;
    this.showItems[i] = false;
    this.mutating = false;

    // Vérifier si la limite est atteinte après ajout
    if (this.savedLotsCount >= AppFormCComponent.MAX_LOTS) {
      this.lotLimitReached = true;
    }

    this.saveToStorage();
  }

  /**
   * Supprime un lot
   *
   * @param i
   */
  deleteItem(i): void {
    this.mutating = true;
    this.hiddenItems.splice(i, 1);
    this.validLots.splice(i, 1);
    this.itemsF2.removeAt(i);
    this.lineIndex = this.lineIndex - 1;
    this.showItems[this.lineIndex] = true;
    this.mutating = false;

    // Réévaluer la limite après suppression
    if (this.savedLotsCount < AppFormCComponent.MAX_LOTS) {
      this.lotLimitReached = false;
    }

    this.saveToStorage();
  }

  /**
   * Affiche un lot
   *
   * @param i
   */
  showItem(i): void {
    if (this.hiddenItems[i]) {
      this.hiddenItems[i] = false;
    } else {
      this.hiddenItems[i] = true;
    }

    this.saveToStorage();
  }

  /**
   * Affiche le message et active la classe d'invalidité pour les champs requis
   *
   * @param dirty
   * @param {string} type
   * @param {string} fieldType
   * @returns {any}
   */
  checkFieldValidity(dirty, type = 'validity', fieldType = 'input'): any {
    const valid = this.formIsValid;

    switch (type) {
      case 'class':
        if (!valid && !dirty) {
          if (fieldType === 'input') {
            return 'is-invalid';
          } else {
            return 'label-is-invalid';
          }
        } else {
          return '';
        }
      default:
        if (!valid && !dirty) {
          return true;
        } else {
          return false;
        }
    }
  }

  /**
   * Appel le webservice récupérant la liste ref naso daf
   *
   */
  loadListeRefnasodaf(): void {
    this._objetsService.listeRefnasodaf().takeWhile(() => this.alive).subscribe(
      result => {
        this.datas = result;
      },
      error => { this.metaData = <any>error }
    );
  }

  /**
   * Ajoute un formGroup pour le FormArray
   *
   * @param type
   * @returns {FormGroup}
   */
  createItem(type): FormGroup {
    if (type === 'form_part1') {
      return this.formBuilder.group({
        c_immeuble: '',
        c_pleine_propriete: false,
        c_nue_propriete: false,
        c_usufruit: false,
        c_type_vente_bat: '',
        c_p__nom: '',
        c_p__prenom: '',
        c_adresse__country: 'FR',
        c_adresse__state: '',
        c_adresse__numero: '',
        c_adresse__type_voie: '',
        c_adresse__nom: '',
        c_adresse__extension: '',
        c_adresse__lieu_dit_bp: '',
        c_adresse__cp: ['', Validators.pattern(/^\d{5}$/)],
        c_adresse__localite: '',
        c_ocp_sol_superficie__terres: 0,
        c_ocp_sol_superficie__pres: 0,
        c_ocp_sol_superficie__vergers: 0,
        c_ocp_sol_superficie__vignes: 0,
        c_ocp_sol_superficie__bois: 0,
        c_ocp_sol_superficie__landes: 0,
        c_ocp_sol_superficie__carrieres: 0,
        c_ocp_sol_superficie__eaux_cadastrees: 0,
        c_ocp_sol_superficie__jardins: 0,
        c_ocp_sol_superficie__terrain_batir: 0,
        c_ocp_sol_superficie__terrains_agrement: 0,
        c_ocp_sol_superficie__sol: 0,
        c_surf_const_sol: 0,
        c_surf_util: 0,
        c_immeuble_niveaux: 0,
        c_immeuble_appartements: 0,
        c_immeuble_autres_locaux: 0,
        c_vente_lot_col: false,
        c_vente_lot_col__text: '',
        c_lotissement: null,
      });
    }

    if (type === 'form_part2') {
      return this.formBuilder.group({
        c_loc_bat_copro__numero: 0,
        c_loc_bat_copro__batiment: '',
        c_loc_bat_copro__etage: '',
        c_loc_bat_copro__quote_part: [0, [Validators.min(0), Validators.max(99)]],
        c_loc_bat_copro__nature: '',
        c_loc_bat_copro__nature_preciser: '',
        c_loc_bat_copro__surface: 0,
        c_loc_bat_copro__bat_acv: '',
        c_loc_bat_copro__reg_cop: '',
        c_loc_bat_copro__num_inscription_copropriete: '',
        c_loc_bat_copro__indivision: ''
      });
    }

    if (type === 'form_part3') {
      return this.formBuilder.group({
        c_droit_sociaux__designation_societe: '',
        c_droit_sociaux__designation_droit: '',
        c_droit_sociaux__nature: '',
        c_droit_sociaux__nombre_parts_cedees: 0,
        c_droit_sociaux__nombre_total_parts: 0,
        c_droit_sociaux__numero_parts: '',
        c_droit_sociaux__majorite_parts: null
      });
    }
  }

  /**
   * Réinitialise les champs en les désactivant en cas de changement sur les champs à choix
   */
  resetFormRubrique($event) {
    const choixImmeuble = this.form1.get('itemsF1').get('0').get('c_immeuble').value;
    const choixRepartition = this.form1.get('itemsF1').get('0').get('c_type_vente_bat').value;
    const cleanFieldsImmeuble = [ 'c_type_vente_bat',
                                  'c_p__nom',
                                  'c_p__prenom',
                                  'c_adresse__country',
                                  'c_adresse__state',
                                  'c_adresse__nom',
                                  'c_adresse__numero',
                                  'c_adresse__type_voie',
                                  'c_adresse__cp',
                                  'c_adresse__localite'];

    const cleanFieldsRepartition = [ 'c_surf_const_sol',
                                     'c_surf_util',
                                     'c_immeuble_niveaux',
                                     'c_immeuble_appartements',
                                     'c_immeuble_autres_locaux',
                                     'c_vente_lot_col',
                                     'c_vente_lot_col__text'];

    for (const fieldI of cleanFieldsImmeuble) {
      switch (choixImmeuble) {
        case 1:
            this.form1.get('itemsF1').get('0').get(fieldI).disable();
          break;
        case 2:
          if (fieldI === 'c_type_vente_bat') {
            this.form1.get('itemsF1').get('0').get(fieldI).enable();
          } else {
            this.form1.get('itemsF1').get('0').get(fieldI).disable();
          }
          break;
        case 3:
          this.form1.get('itemsF1').get('0').get(fieldI).enable();
          break;
      }
    }

    switch (choixRepartition) {
      case 1:
        for (const fieldR of cleanFieldsRepartition) {
          this.form1.get('itemsF1').get('0').get(fieldR).enable();
        }
        this.form3.disable();
        const formInit = this.form2Data.controls[this.form2Data.controls.length - 1];
        this.form2Data.controls = [];
        this.form2Data.controls.push(formInit);
        this.lineIndex = 0;
        this.hiddenItems = [];
        this.showItems = [];
        this.showItems.push(true);
        break;
      case 2:
        this.form3.enable();
        for (const fieldR of cleanFieldsRepartition) {
          this.form1.get('itemsF1').get('0').get(fieldR).disable();
        }
        break;


    }

  }

  disableOnUncheck(fieldName, fieldNameText): void {
    const choix = this.form1.get('itemsF1').get('0').get(fieldName).value;

    if (choix === true) {
      this.form1.get('itemsF1').get('0').get(fieldNameText).enable();
    } else {
      this.form1.get('itemsF1').get('0').get(fieldNameText).disable();
    }
  }

  getTooltip(): void {
    this.formTooltip = [
      {text:'les renseignements à fournir ne doivent porter que sur le bâtiment principal (la maison par exemple)'},
      {text:'peut-être indiquée approximativement'},
      {text:'les niveaux s’entendent, tant des étages proprement dits que des sous-sols, rez-de-chaussées ou combles le cas échéant'},
      {text:'il s’agit des locaux principaux affectés à un usage autre que d’habitation (bureaux, magasins par exemple)'},
      {text:'précisez s’il s’agit d’un appartement, d’une cave, d’un box pour automobile, etc. '},
      {text:'elle n’est à indiquer que pour les locaux principaux (appartements bureaux, etc.)'},
      {text:'si cette rubrique doit être remplie, il est nécessaire de remplir également la rubrique précédente ' +
        '« locaux dans un bâtiment en copropriété » '},
      {text:'parts ou actions par exemple'},
    ];
  }

  /**
   * Propage les valeurs des champs partagés vers tous les lots enregistrés.
   */
  private propagateSharedFieldsToLots(values: any): void {
    const controls = this.form2Data.controls;
    for (let i = 0; i < controls.length; i++) {
      controls[i].patchValue({
        c_loc_bat_copro__bat_acv: values.c_loc_bat_copro__bat_acv,
        c_loc_bat_copro__reg_cop: values.c_loc_bat_copro__reg_cop,
        c_loc_bat_copro__num_inscription_copropriete: values.c_loc_bat_copro__num_inscription_copropriete
      }, { emitEvent: false });
    }
    if (!this.mutating) { this.saveToStorage(); }
  }

  /**
   * Propage les valeurs des champs partagés vers un lot spécifique.
   */
  private propagateSharedFieldsToLot(index: number): void {
    const values = this.formCopro.value;
    this.form2Data.at(index).patchValue({
      c_loc_bat_copro__bat_acv: values.c_loc_bat_copro__bat_acv,
      c_loc_bat_copro__reg_cop: values.c_loc_bat_copro__reg_cop,
      c_loc_bat_copro__num_inscription_copropriete: values.c_loc_bat_copro__num_inscription_copropriete
    }, { emitEvent: false });
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    // Lots enregistrés (exclure la dernière entrée vide = formulaire d'ajout)
    const lotsControls = this.form2Data.controls;
    const lots = [];
    for (let i = 0; i < lotsControls.length - 1; i++) {
      lots.push(lotsControls[i].value);
    }

    const currentLotForm = this.showItems[this.lineIndex]
      ? this.form2Data.at(this.lineIndex).value
      : null;

    this.localStorageService.save('form_c', {
      form1Values: this.form1Data.at(0).value,
      lots,
      currentLotForm,
      form3Values: this.form3Data.at(0).value,
      formCoproValues: this.formCopro.value,
      lotLimitReached: this.lotLimitReached
    });
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   * Reconstruit le FormArray des lots et réapplique l'état conditionnel.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_c');
    if (!saved) { return; }

    // Restaurer form1
    if (saved.form1Values) {
      this.form1Data.at(0).patchValue(saved.form1Values, { emitEvent: false });
    }

    // Restaurer les lots (form2 FormArray)
    const savedLots: any[] = saved.lots;
    if (savedLots && savedLots.length > 0) {
      // RAZ
      while (this.form2Data.length > 0) {
        this.form2Data.removeAt(0);
      }
      this.hiddenItems = [];
      this.showItems = [];

      // Première entrée
      const firstLot = this.createItem('form_part2');
      this.form2Data.push(firstLot);
      this.form2Data.at(0).patchValue(savedLots[0], { emitEvent: false });
      this.hiddenItems[0] = true;
      this.showItems[0] = false;

      // Entrées suivantes
      for (let i = 1; i < savedLots.length; i++) {
        const group = this.createItem('form_part2');
        this.form2Data.push(group);
        this.form2Data.at(i).patchValue(savedLots[i], { emitEvent: false });
        this.hiddenItems[i] = true;
        this.showItems[i] = false;
      }

      // Entrée vide pour le prochain ajout
      const emptyLot = this.createItem('form_part2');
      this.form2Data.push(emptyLot);
      this.lineIndex = savedLots.length;
      this.showItems[this.lineIndex] = true;
      this.itemsF2 = this.form2Data;
    }

    // Restaurer le brouillon du lot en cours si présent
    if (saved.currentLotForm) {
      this.form2Data.at(this.lineIndex).patchValue(saved.currentLotForm, { emitEvent: false });
    }

    // Restaurer form3
    if (saved.form3Values) {
      this.form3Data.at(0).patchValue(saved.form3Values, { emitEvent: false });
    }

    // Restaurer les champs partagés de copropriété
    if (saved.formCoproValues) {
      this.formCopro.patchValue(saved.formCoproValues, { emitEvent: false });
    }

    // Restaurer l'état de la limite de lots
    if (saved.lotLimitReached) {
      this.lotLimitReached = saved.lotLimitReached;
    }

    // Réappliquer l'état enabled/disabled des champs conditionnels
    if (saved.form1Values) {
      this.resetFormRubrique(null);
      // Restaurer également l'état de la checkbox c_vente_lot_col
      this.disableOnUncheck('c_vente_lot_col', 'c_vente_lot_col__text');
    }

    // Marquer les champs restaurés comme dirty pour éviter les faux positifs de validation
    this.markFilledControlsDirty(this.form1Data.at(0));
    this.markFilledControlsDirty(this.form3Data.at(0));
    for (let i = 0; i < this.form2Data.length; i++) {
      this.markFilledControlsDirty(this.form2Data.at(i));
    }

    // Re-synchroniser les selects des lots après que Angular a rendu le DOM
    setTimeout(() => this.resyncLotSelects());
  }

  /**
   * Marque comme dirty tous les contrôles du groupe ayant une valeur non vide.
   * Nécessaire après patchValue pour que checkFieldValidity n'affiche pas
   * d'erreur sur les champs restaurés depuis le localStorage.
   */
  private markFilledControlsDirty(group: any): void {
    if (!group || !group.controls) { return; }
    Object.keys(group.controls).forEach(key => {
      const val = group.controls[key].value;
      if (val !== null && val !== '' && val !== undefined) {
        group.controls[key].markAsDirty();
      }
    });
  }

  /**
   * Vérifie si le pays sélectionné est la France.
   * Utilisé dans le template pour conditionner la validation du code postal.
   */
  isFrance(item: any): boolean {
    return item.get('c_adresse__country').value === 'FR';
  }

  /**
   * Abonne le champ code postal aux changements de pays :
   * en France → pattern 5 chiffres, à l'étranger → pas de contrainte de format.
   */
  private setupCpLogic(group: FormGroup, countryField: string, cpField: string): void {
    group.get(countryField).valueChanges.subscribe(country => {
      const cpControl = group.get(cpField);
      if (country === 'FR') {
        cpControl.setValidators([Validators.required, Validators.pattern(/^\d{5}$/)]);
      } else {
        cpControl.setValidators([Validators.required]);
      }
      cpControl.updateValueAndValidity();
    });
  }

  /**
   * Force la re-synchronisation des selects des lots (nature, bat_acv, reg_cop)
   * après que Angular a rendu les options dans le DOM.
   * Nécessaire car les selects sont derrière des *ngIf et le patchValue
   * a lieu avant le rendu.
   */
  private resyncLotSelects(): void {
    const f2Controls = this.form2Data.controls;
    for (let i = 0; i < f2Controls.length; i++) {
      const natureValue = f2Controls[i].get('c_loc_bat_copro__nature').value;
      if (natureValue && natureValue !== '') {
        f2Controls[i].get('c_loc_bat_copro__nature').setValue(natureValue, { emitEvent: false });
      }
    }
    // Re-synchroniser les selects partagés
    const batAcvValue = this.formCopro.get('c_loc_bat_copro__bat_acv').value;
    if (batAcvValue && batAcvValue !== '') {
      this.formCopro.get('c_loc_bat_copro__bat_acv').setValue(batAcvValue, { emitEvent: false });
    }
    const regCopValue = this.formCopro.get('c_loc_bat_copro__reg_cop').value;
    if (regCopValue && regCopValue !== '') {
      this.formCopro.get('c_loc_bat_copro__reg_cop').setValue(regCopValue, { emitEvent: false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-c/app-form-c.component.ts